import PropTypes from 'prop-types'
import React, { Component } from 'react'
import convert from '../convert'
import { FormattedUnit, formatUnit } from '../format'
import { providerTypes, propTypes } from '../types'
import { SHORT, SECONDS, HOURS, MINUTES, DAYS, WEEKS, MONTHS, YEARS } from '../constants'

export const SECONDS_IN_YEAR = 31536000
export const SECONDS_IN_MONTH = 2678400
export const SECONDS_IN_DAY = 86400
export const SECONDS_IN_HOUR = 3600
export const SECONDS_IN_MINUTE = 60

export function getDurationTo ({ value, to, from = SECONDS }) {
  if (to) { return to }
  let _to = SECONDS
  let _value = value

  if (from !== SECONDS) {
    _value = convert(value, { from, to: SECONDS })
  }

  if (_value >= SECONDS_IN_YEAR) {
    _to = YEARS
  } else if (_value >= SECONDS_IN_MONTH) {
    _to = MONTHS
  } else if (_value >= SECONDS_IN_DAY) {
    _to = DAYS
  } else if (_value >= SECONDS_IN_HOUR) {
    _to = HOURS
  } else if (_value >= SECONDS_IN_MINUTE) {
    _to = MINUTES
  }

  return _to
}

export function formatDuration ({ from = SECONDS, unit = SHORT, digits = 1, to: _to, value, ...rest }) {
  const to = getDurationTo({ value, to: _to, from })
  return formatUnit({ ...rest, value, from, to, unit, digits })
}

export function durationFormatter ({ intl, locale, system }) {
  return ({ ...options }) => formatDuration({ ...options, intl, locale, system })
}

export class FormattedDuration extends Component {
  static contextTypes = providerTypes;

  static propTypes = {
    ...propTypes,
    to: PropTypes.oneOf([ SECONDS, MINUTES, HOURS, DAYS, WEEKS, MONTHS, YEARS ]),
    from: PropTypes.oneOf([ SECONDS, MINUTES, HOURS, DAYS, WEEKS, MONTHS, YEARS ]),
  };

  static defaultProps = {
    from: SECONDS,
    unit: SHORT,
    digits: 1,
  };

  render () {
    const { value, from, to: _to, ...rest } = this.props
    const to = getDurationTo({ value, from, to: _to })
    return React.createElement(FormattedUnit, { ...rest, to, from, value })
  }
}



// WEBPACK FOOTER //
// ./src/shared/units/metrics/duration.js